import { CSVLink } from "react-csv";
import { useEffect, useState } from "react";
import { useColumnsAnalitySize } from "../hooks/useColumnsAnalitySize";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import moment from "moment";


const headerCsv = [
    { label: 'Nombre', key: 'name' },
    { label: 'Tamaño', key: 'size' },
    { label: 'Estatus', key: 'status' },
    { label: 'Descripción', key: 'descriptionDevelopment' },
    { label: 'Presupuesto', key: 'budgetDevelopment' },
    { label: '%', key: 'budgetpercentageDevelopment' },
    { label: 'Trabajo', key: 'workDevelopment' },
    { label: '%', key: 'workpercentageDevelopment' },
    { label: 'Descripción', key: 'descriptionPlanning' },
    { label: 'Presupuesto', key: 'budgetPlanning' },
    { label: '%', key: 'budgetpercentagePlanning' },
    { label: 'Trabajo', key: 'workPlanning' },
    { label: '%', key: 'workpercentagePlanning' },
];



const ProjectInfo = ({ isLoading, projects = [], filterProject, filterValue, filteredProjects = [], setFilterValue, projectsRef, }) => {
    const [tableInfo, setTableInfo] = useState([]);
    const { expandedTable, getExpandedColumns, getExpandedTableData } = useColumnsAnalitySize({ filterValue, });
    const [downloadedInfo, setDownloadedInfo] = useState([]);


    useEffect(() => {
        setTableInfo(() => {
            return filteredProjects.map(project => ({ name: project.name, size: project.size, key: project.name, ...project, status: project.status }))
        })
    }, [filteredProjects]);


    useEffect(() => {
        setDownloadedInfo(filteredProjects.map(project => {
            const [development, planning] = getExpandedTableData(project);
            const {
                description: descriptionDevelopment,
                budget: budgetDevelopment,
                budgetpercentage: budgetpercentageDevelopment,
                work: workDevelopment,
                workpercentage: workpercentageDevelopment,
            } = development;
            const {
                description: descriptionPlanning,
                budget: budgetPlanning,
                budgetpercentage: budgetpercentagePlanning,
                work: workPlanning,
                workpercentage: workpercentagePlanning,
            } = planning;
            return { ...project, descriptionDevelopment, budgetDevelopment, budgetpercentageDevelopment, workDevelopment, workpercentageDevelopment, descriptionPlanning, budgetPlanning, budgetpercentagePlanning, workPlanning, workpercentagePlanning }
        }))
    }, [filteredProjects, getExpandedTableData])





    return (
        <div className="w-full grow   flex justify-center">
            <CSVLink headers={headerCsv} filename={`project-hours-${moment().format('YYYY-MM-DD HH:mm')}`} data={downloadedInfo} ref={projectsRef} className="hidden" />

            <div className="w-[400px] md:w-full max-w-[900px]">
                <TableGeneral
                    column={getExpandedColumns(projects)}
                    handleChange={(_, filters, __) => {
                        setFilterValue({ size: filters.size, status: filters.status })
                        filterProject(filters.size, filters.status);
                    }}
                    state={tableInfo}
                    tableProps={{
                        size: "large",
                        scroll: { x: 400, y: null },
                        bordered: true,
                        expandable: {
                            expandedRowRender: expandedTable
                        }
                    }}
                    loading={isLoading}
                    pagination={{ position: ["none", "none"], pageSize: tableInfo.length }}
                />
            </div>
        </div>
    );
}

export default ProjectInfo;
